import { useCallback } from 'react';
import styled from 'styled-components';
import { SongSlug } from '../../../../common/src/model.ts';
import { useCurrentOrg } from '../../data/use_current_org.tsx';
import { CheckBox } from '../../util/check_box.tsx';

const HiddenSongWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;
const HiddenSongText = styled.div`
  font-family: Jost-Regular, sans-serif;
  font-size: 1.1rem;
  cursor: pointer;
`;

export function HiddenSongCheckBox({
  isHiddenSong,
  setHiddenSong,
}: {
  isHiddenSong: boolean;
  setHiddenSong: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const onCheckHiddenSong = useCallback(() => {
    setHiddenSong((isHiddenSong) => !isHiddenSong);
  }, [setHiddenSong]);
  return (
    <HiddenSongWrapper>
      <CheckBox isChecked={isHiddenSong} onClick={onCheckHiddenSong} />
      <HiddenSongText onClick={onCheckHiddenSong}>Hide in &quot;Our Hymnal&quot;</HiddenSongText>
    </HiddenSongWrapper>
  );
}

export function useSongVisibility(): {
  setSongVisibility: ({ songSlug, isVisible }: { songSlug: SongSlug; isVisible: boolean }) => Promise<void>;
} {
  const { currentOrg, updateOrgInfo } = useCurrentOrg();
  const setSongVisibility = useCallback(
    async ({ songSlug, isVisible }: { songSlug: SongSlug; isVisible: boolean }) => {
      if (!currentOrg) {
        console.error(`setSongVisibility: Missing org`);
        return;
      }
      let hiddenSongs: SongSlug[];
      if (isVisible) {
        hiddenSongs = currentOrg.hiddenSongs?.filter((currentSongSlug) => currentSongSlug !== songSlug) ?? [];
      } else {
        hiddenSongs = [...(currentOrg.hiddenSongs ?? []), songSlug];
      }
      await updateOrgInfo({ id: currentOrg.id, hiddenSongs });
    },
    [currentOrg, updateOrgInfo],
  );
  return { setSongVisibility };
}
